import snakecaseKeys from 'snakecase-keys';
import { useInvalidateQueries } from '@leagueplatform/core';
import {
  GET_USER_PROFILE_MESSAGE_TYPE,
  setUserProfile,
  UserProfile,
} from '@leagueplatform/user-profile-api';
import { useMutation } from 'react-query';
import { useCallback } from 'react';

export interface Options {
  onSuccess?: () => void;
  onError?: () => void;
}

export const useUpdateUserProfile = (options?: Options) => {
  const invalidateQueries = useInvalidateQueries({
    queryKey: [GET_USER_PROFILE_MESSAGE_TYPE],
  });
  const { onSuccess, onError } = options || {};
  const { mutateAsync: updateUserProfileMutation, isLoading } = useMutation(
    (userProfile: Partial<UserProfile>) => setUserProfile(userProfile),
    {
      onSuccess: () => {
        invalidateQueries();
        if (onSuccess) onSuccess();
      },
      onError: () => {
        if (onError) onError();
      },
    },
  );

  const updateUserProfile = useCallback(
    async (userProfile: any) => {
      const serializedBody = snakecaseKeys(userProfile);
      await updateUserProfileMutation(serializedBody);
    },
    [updateUserProfileMutation],
  );

  return { updateUserProfile, isLoading };
};
